var _style, _g, _g2, _path, _rect, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViacAthletes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1325.7 153.5",
    style: {
      enableBackground: "new 0 0 1325.7 153.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3400C7;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.5,114.1c-5.7,10.7-15.7,17-30.4,17c-24.8,0-40.6-22.6-40.6-56.8S309.6,19,335.1,19 c17.7,0,28.5,9.9,32.8,25.4H388C383.3,21.2,364.9,4,336.3,4c-35.8,0-60.6,28.1-60.6,70.2c0,44,23,71.5,59.8,71.5 c25.3,0,42.6-11.8,50-31.7L365.5,114.1L365.5,114.1L365.5,114.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.1,36.9c1.6-4.7,2.9-8.8,4.3-13.3l4.5,13.3l18,52h-44.7L223.1,36.9z M288.1,144.5L238,6.5h-21.8l-48.5,138 h18.4l14-40.7h54.8l14.1,40.7H288.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.2,6.5v5.7c21.7,0,30.3,3.8,26.2,16c-6.8,21.2-22.9,62.7-33.4,89.3h-0.4C60.3,80.9,44.9,39.9,39.4,24.8 c-3.4-9.4-2.6-10.9,12.5-12.6V6.5H0v5.9c12.5,1.1,15.9,2.8,22,18.7C34.1,61.4,51,106,65.1,144.5h8.1C89,101.1,110.8,48.6,116.5,35 c7.4-17.6,10.8-22.4,21.9-22.4s16.6,3,10.3,20.5l-30.7,85c-6.6,18.1-8.7,19.4-26.5,20.6l-2.2,5.8h79.2l2.2-5.8 c-16.9-1.3-42.8,2-34.7-20.6L166.8,33c6.6-18.1,8.7-19.4,26.5-20.6l1.8-5.9L82.2,6.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 439,
    y: 6.4,
    className: "st1",
    width: 905.2,
    height: 138.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.2,144.7l-14.3-41.9h-52.9l-14.5,41.9h-19.1L483,6.8h21.5l49.2,137.9H534.2z M472.5,86.6h41.7l-20.8-60.5 L472.5,86.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M649.4,6.8v16.2h-45.7v121.8h-18.1V22.9h-45.8V6.8H649.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M747.4,6.8h18.1v137.9h-18.1V81.5h-61.6v63.2h-18.1V6.8h18.1v58.6h61.6V6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M816.3,128.4h60.1v16.4h-78.2V6.8h18.1V128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M913.3,127.8h67.8v16.9h-85.9V6.8H981v16.7h-67.6v42.8h61.3v16.2h-61.3V127.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1103.4,6.8v16.2h-45.7v121.8h-18.1V22.9h-45.8V6.8H1103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1139.9,127.8h67.8v16.9h-85.9V6.8h85.7v16.7h-67.6v42.8h61.3v16.2h-61.3V127.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1226.6,102h18.6c0.6,16.4,13.4,28.8,33.7,28.8c15.4,0,28-7.9,28-23.3c0-11.3-6.2-17.4-23.1-21.5l-17.3-4.1 c-24.2-5.8-36.5-15.8-36.5-37.4c0-22.7,18.8-40.4,47.3-40.4c29.1,0,45.9,18.3,46.8,40.4h-18.7c-0.7-12.9-9.7-23.9-28.8-23.9 c-15.8,0-28,8.7-28,22.2c0,10.3,6.3,17,22.8,21.1l20.3,5c18.8,4.6,34,14.1,34,36.2c0,25.5-18.6,42.4-47.1,42.4 C1247.3,147.5,1227,130.3,1226.6,102z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViacAthletes);
export default __webpack_public_path__ + "static/media/viac-athletes.5712a14a70138e7cb2d51fc95f36ede3.svg";
export { ForwardRef as ReactComponent };